import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card } from 'antd';
import SupplierInvoiceForm from '../supplier_invoice_form/SupplierInvoiceForm';
import { createInvoiceBasedOnWorkOrder } from '../../thunks/invoices_thunks';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';

const queryString = require('qs');
const { Content } = Layout;

class NewSupplierInvoicePage extends React.Component<any, any> {
	state = {
		invoiceFormData: {},
		invoiceFormDataLoading: true,
	};

	componentDidMount() {
		const { createInvoiceWithWorkOrderId, match, location, saveFormData } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}

		const queryParams = queryString.parse(searchString);
		const workOrderId = queryParams.workOrderId || match.params.id;

		createInvoiceWithWorkOrderId(workOrderId, {}).then((invoice) => {
			this.setState({ invoiceFormData: { ...invoice }, invoiceFormDataLoading: false });
		});
	}

	render() {
		const { history, location, match, invoicesFormData } = this.props;

		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}

		const queryParams = queryString.parse(searchString);
		const workOrderId = queryParams.workOrderId || match.params.id;

		return this.state.invoiceFormDataLoading ? (
			<PageLoadingPlaceholder />
		) : (
			<Content>
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<Row style={{ margin: '0.5em -8px' }} gutter={16}>
					<Col span={24}>
						<Card>
							<div>
								<h5 style={{ marginBottom: 24 }}>Create Invoice</h5>
								<SupplierInvoiceForm
									formData={this.state.invoiceFormData}
									onSuccess={history.goBack}
								/>
							</div>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({
	createInvoiceWithWorkOrderId: (workOrderId, entity) =>
		dispatch(createInvoiceBasedOnWorkOrder(workOrderId)(entity)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(NewSupplierInvoicePage)
);
